function gtg() {
    dataLayer.push(arguments);
};

export const gaEngagement = (action, label) => {
    gtg('event', action, {
        event_category: 'engagement',
        event_label: label,
    });
};

export const gaConversion = (action, sendTo, txnID) => {
    gtg('event', action, {
        send_to: sendTo || process.env.VUE_APP_GOOGLE_ANALYTICS_SEND_TO,
        transaction_id: txnID,
    });
};

export const pauseSubscription = (stepAttempt, pauseReason) => {
    dataLayer.push({
        event: 'pauseSubscription',
        pause: {
            step: 'attempt',
            reason: pauseReason,
            resolution: stepAttempt,
        },
    });
};
